import { AlertDialog } from "../../common/AlertDailog";
import DynamicForm from "../../common/DynamicForm";
import { useForm } from "react-hook-form";
import {
  metadataCodelistFieldSchema,
  metadataFieldSchema,
} from "./metadataFieldSchema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useSnackbar } from "../../../hooks/useSnackbar";
import { useEffect, useState } from "react";

const AddMetadataFieldForm = (props: any) => {
  const {
    openMetadataField,
    setOpenMetadataField,
    setRows,
    rows,
    selectedFieldData,
    setSeletedFieldData,
    allCodelistData,
  } = props;

  const { showSuccess, showError } = useSnackbar();
  const booleanOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];
  const addMetadataFieldJson = [
    {
      label: "Name",
      name: "field_name",
      required: true,
      size: 4,
    },
    {
      label: "Type",
      name: "field_type",
      required: true,
      size: 4,
    },
    {
      label: "Description",
      name: "description",
      size: 4,
    },
    {
      label: "Required",
      name: "required",
      required: true,
      size: 4,
      inputType: "dropdown",
      options: booleanOptions,
    },
    {
      label: "Referrence Entity",
      name: "parent",
      size: 4,
    },
    {
      label: "Record ID Display",
      name: "title",
      size: 4,
    },
    {
      label: "Max Length",
      name: "max_length",
      required: true,
      size: 4,
      type: "number",
    },
    {
      label: "Codelist",
      name: "code_list_value",
      required: false,
      size: 4,
      visibility: "false",
      inputType: "dropdown",
      options:
        allCodelistData?.count > 0
          ? allCodelistData.result?.map((item: any) => {
              return {
                label: item.code_list_code,
                value: item.code_list_code,
              };
            })
          : [],
    },
  ];

  const values =
    Object.keys(selectedFieldData).length > 0 ? selectedFieldData : {};

  const [fields, setFields] = useState<any>(addMetadataFieldJson);

  const [schema, setSchema] = useState<any>(metadataFieldSchema);

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    watch,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {},
    values,
  });

  const watchType = watch("field_type");

  console.debug(watchType);

  useEffect(() => {
    if (watchType?.toLowerCase() == "codelist") {
      setSchema(metadataCodelistFieldSchema);
      const temp = addMetadataFieldJson?.map((item) => {
        if (item.name == "code_list_value") {
          return {
            ...item,
            visibility: "true",
            required: true,
          };
        } else {
          return item;
        }
      });
      setFields(temp);
    } else {
      setSchema(metadataFieldSchema);
      setFields(addMetadataFieldJson);
    }
  }, [watchType]);

  const submit = (data: any) => {
    if (rows.find((item: any) => item.field_name == data.field_name)) {
      showError("Field name already exists");
      return;
    }
    setRows([...rows, { ...data, id: data.field_name }]);
    setOpenMetadataField(false);
    showSuccess("Field details added", "field-add-success");
  };

  const onInvalid = (data: any) => {
    console.debug(data);
  };

  return (
    <AlertDialog
      open={openMetadataField}
      handleClose={() => {
        setOpenMetadataField(false);
        setSeletedFieldData({});
      }}
      handleConfirm={handleSubmit(submit, onInvalid)}
      title={
        Object.keys(selectedFieldData).length > 0 ? "Edit Field" : "Add Field"
      }
      maxWidth="md"
      // saveDisable="true"
    >
      <DynamicForm
        fieldsJson={fields}
        control={control}
        register={register}
        errors={errors}
      />
    </AlertDialog>
  );
};

export default AddMetadataFieldForm;
